package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.list_device


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class DeviceItem(
    @SerialName("hardwareId")
    val hardwareId: String?,
    @SerialName("__typename")
    val typename: String?
)